<template>
  <!-- 头部导航部分 -->
  <div class="E_head">
    <!-- 导航条上半部分 -->
    <div class="E_top_head_box">
      <div class="E_top_head E_contentBox">
        <!-- 导航条上半部分 - 最左边 -->
        <div class="E_contentBox_left">
          <a href="/">
            <div class="E_logo_box">
              <img
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/icon/logo2.png"
              />
            </div>
            <div class="E_heng"></div>
            <div class="E_Logo_title">选课中心</div>
          </a>
        </div>
        <!-- 导航条上半部分 - 最中间 -->
        <div class="E_contentBox_center">
          <div class="E_contentBox_left_one E_cursor_pointer">
            <p class="E_contentBox_left_one_p">网校导航</p>
            <i class="iconfont icon-DownSanjiao"></i>
            <ul class="E_shoolNav_box">
              <li>
                <a href="/"> 网校首页 </a>
              </li>
              <li>
                <a href="/jszp"> 考试资讯 </a>
              </li>
              <li>
                <a href="/Productcentre?type=class"> 网校课程 </a>
              </li>
              <li>
                <a href="/Productcentre?type=live"> 直播课程 </a>
              </li>
              <li>
                <a href="/Productcentre?type=face"> 面授课程 </a>
              </li>
              <li>
                <a href="https://shop562726024.taobao.com/"> 图书教材 </a>
              </li>
              <li>
                <a href="/tk"> 考试题库 </a>
              </li>
              <li>
                <a href="/tk"> 历年真题 </a>
              </li>
              <!-- <li>
                                <a href="javascript:;">
                                    热门活动
                                </a>
                            </li> -->
              <li>
                <a href="http://www.5ksw.com/contact"> 联系我们 </a>
              </li>
            </ul>
          </div>
          <a
            class="E_contentBox_center_one E_cursor_pointer E_kefu_tips_parent"
          >
            <div class="E_contentBox_center_img">
              <img
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_official.png"
              />
            </div>
            <p class="E_contentBox_center_p">公众号</p>
            <!-- 气泡框 -->
            <div class="E_kefu_tips_box E_kefu_tips_bottom">
              <div class="E_kefu_tips_box_img">
                <img
                  src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/eiditIndex_img/head/gongzhonghao.jpg"
                  alt=""
                />
              </div>
            </div>
          </a>
          <a
            target="_blank"
            href="https://www.douyin.com/user/MS4wLjABAAAAMhzrPdB-Sn2iOVPMNg1dtU-1wbDXJRs-9DLgsfitWc4"
            class="E_contentBox_center_two E_cursor_pointer E_kefu_tips_parent"
          >
            <div class="E_contentBox_center_img">
              <img
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_Tiktok.png"
              />
            </div>
            <p class="E_contentBox_center_p">抖音</p>
            <!-- 气泡框 -->
            <div class="E_kefu_tips_box E_kefu_tips_bottom">
              <div class="E_kefu_tips_box_img">
                <img
                  src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/eiditIndex_img/head/douyin.jpg"
                  alt=""
                />
              </div>
            </div>
          </a>
          <a
            class="
              E_contentBox_center_three E_cursor_pointer E_kefu_tips_parent
            "
          >
            <div class="E_contentBox_center_img">
              <img
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_video.png"
              />
            </div>
            <p class="E_contentBox_center_p">视频号</p>
            <!-- 气泡框 -->
            <div class="E_kefu_tips_box E_kefu_tips_bottom">
              <div class="E_kefu_tips_box_img">
                <img
                  src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/eiditIndex_img/head/shipinghao.png"
                  alt=""
                />
              </div>
            </div>
          </a>
          <a
            href="javascript:;"
            class="E_contentBox_center_four E_cursor_pointer E_kefu_tips_parent"
          >
            <div class="E_contentBox_center_img">
              <img
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_chairman.png"
              />
            </div>
            <p class="E_contentBox_center_p">小红书</p>
            <div class="E_kefu_tips_box E_kefu_tips_bottom">
              <div class="E_kefu_tips_box_img">
                <img
                  src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/eiditIndex_img/head/redBox.png"
                  alt=""
                />
              </div>
            </div>
          </a>
          <!-- <a target="_blank" href="https://www.zhihu.com/people/yuan-meng-jiao-shi" class="E_contentBox_center_five E_cursor_pointer">
                        <div class="E_contentBox_center_img">
                            <img src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_Know.png">
                        </div>
                        <p class="E_contentBox_center_p">知乎</p>
                    </a> -->
          <a
            href="https://space.bilibili.com/1384542261"
            target="_blank"
            class="E_contentBox_center_six E_cursor_pointer"
          >
            <div class="E_contentBox_center_img">
              <img
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_bibi.png"
              />
            </div>
            <p class="E_contentBox_center_p">B站</p>
          </a>
          <a
            href="tel:400-0057-228"
            class="E_contentBox_center_seven E_cursor_pointer"
          >
            <div class="E_contentBox_center_img">
              <img
                src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_Hotline.png"
              />
            </div>
            <p class="E_contentBox_center_p">400-0057-228</p>
          </a>
        </div>
        <!-- 导航条上半部分 - 最右边 -->
        <!-- 未登录状态 -->
        <div class="E_contentBox_right">
          <div class="E_contentBox_right_login" v-if="!loginStatus">
            <a href="javascript:;" class="E_login_box" @click="Mylogin()">
              <div class="E_contentBox_right_portrait">
                <img
                  src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/product/E_hrader/icon_portrait.png"
                />
              </div>
              <div class="E_cursor_pointer">登录</div>
            </a>
            <span class="E_span"></span>
            <a href="javascript:;" @click="MyRegister()">
              <div class="E_cursor_pointer">注册</div>
            </a>
          </div>
          <!-- 已登录状态 -->
          <div class="E_contentBox_right_login" v-else>
            <div class="E_islogin_box">
              <div class="E_head_img">
                <a href="/home" target="_blank"
                  ><img
                    :src="
                      MyuserInfo.avatar == null
                        ? 'http://hnjszp.xueba.hk/static/platform/pic/img_headpic.png'
                        : MyuserInfo.avatar
                    "
                    alt=""
                    title="头像"
                /></a>
              </div>
              <div class="E_name" @click="home">
                <a
                  class="dy_my_new_name"
                  href="/home"
                  title="名字"
                  target="_blank"
                >
                  <span>{{ MyuserInfo.username }} </span>
                </a>
              </div>
              <div class="E_logout">
                <a href="javascript:;" @click.stop="myOutlogin()">
                  退出登录
                  <i class="iconfont icon-tuichudenglu"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Head",
  data() {
    return {
      // 动态地址
      // 课程中心
      zhongxing: "#",
      // 高分题库
      tiku: "#",
      // 教考资讯
      zixun: "#",
      //免费文库
      wenku: "#",
    };
  },
  computed: {
    ...mapState(["loginStatus", "MyuserInfo"]),
  },
  methods: {
    ...mapMutations(["outLogin", "userInfo"]),
    jup() {
      window.location.href = window.location.origin;
    },
    // 登录
    Mylogin() {
      let nowUrl = window.location.href;
      nowUrl = nowUrl.replace(/#/g, "vue");
      let url = window.location.origin;
      if (sessionStorage.getItem("distrid") != null) {
        window.location.href =
          url +
          "/login?turn_jump_url=" +
          nowUrl +
          "&distrid=" +
          sessionStorage.getItem("distrid");
      } else {
        window.location.href = url + "/login?turn_jump_url=" + nowUrl;
      }
    },
    // 注册
    MyRegister() {
      let nowUrl = window.location.href;
      nowUrl = nowUrl.replace(/#/g, "vue");
      let url = window.location.origin;
      if (sessionStorage.getItem("distrid") != null) {
        window.location.href =
          url +
          "/register?turn_jump_url=" +
          nowUrl +
          "&distrid=" +
          sessionStorage.getItem("distrid");
      } else {
        window.location.href = url + "/register?turn_jump_url=" + nowUrl;
      }
    },
    // 退出登录
    myOutlogin() {
      this.outLogin();
      window.localStorage.removeItem("token");
      let nowUrl = window.location.href;
      nowUrl = nowUrl.replace(/#/g, "vue");
      let url = window.location.origin;
      window.location.href = url + "/logout?turn_jump_url=" + nowUrl;
    },
    test() {
      // document.cookie="username=John Doe"
      var keys = document.cookie.match(/[^ =;]+(?==)/g);
      if (keys) {
        for (var i = keys.length; i--; ) {
          document.cookie =
            keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下的,例如：m.kevis.com
          document.cookie =
            keys[i] +
            "=0;path=/;domain=" +
            document.domain +
            ";expires=" +
            new Date(0).toUTCString(); //清除当前域名下的，例如 .m.kevis.com
          document.cookie =
            keys[i] +
            "=0;path=/;domain=kevis.com;expires=" +
            new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
        }
      }
    },
    home() {
      let url = window.location.origin;
      window.location.href = url + "/home";
    },
    // 动态获取当前根目录地址
    autoUrl() {
      let url = window.location.origin;
      this.zhongxing = url + "/course";
      this.tiku = url + "/tk";
      this.zixun = url + "/realtimeinfo_list";
      this.wenku = url + "/library_index";
    },
  },
  mounted() {
    this.autoUrl();
  },
};
</script>

<style lang="less" scoped>
// 元素主要背景部分
.mainBgColor {
  background: #ffffff;
}

// flex布局
.flexStyle(@direction, @item, @justify) {
  display: flex;
  flex-direction: @direction;
  align-items: @item;
  justify-content: @justify;
}

//小手
.E_cursor_pointer {
  cursor: pointer;
}

//input 清除input 默认样式
input:focus {
  outline: none;
}

//去除button 默认事件
button:focus {
  outline: none;
}

//absolute 绝对居中
.E_absolute {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}

//absolute 上下居中
.E_absolute_item {
  position: absolute;
  bottom: 0;
  top: 0;
  margin: auto;
}

//超出文本隐藏
.E-p_nowrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

// 鼠标悬浮颜色
.hoverColor {
  color: #ec5934;
}
@media( max-width: 1400px ) {
    .E_head {
      margin: auto;
      width: 100% !important;
    }

    .E_contentBox_center {
      display: none !important;
    }

    .E_contentBox {
      justify-content: space-between !important;
    }
}
//导航条
.E_head {
  margin: auto;
  width: 1440px;
  .mainBgColor();

  //导航条上半部分
  .E_top_head_box {
    width: 100%;

    .E_contentBox_left_one {
      position: relative;
      &:hover {
        .E_shoolNav_box {
          max-height: 99rem;
        }
      }

      .icon-DownSanjiao {
        font-size: 12px;
        transform: scale(0.8);
        color: #666666;
      }

      .E_shoolNav_box {
        overflow: hidden;
        max-height: 0px;
        transition: all 0.75s ease;
        z-index: 9;
        transform: translateY(100%);
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 0 0.1875rem;
        background-color: #fff;
        border: 1px solid #f1f2f3;
        box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 6%);

        li {
          text-align: center;
          height: 2.125rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 0.8rem;
          font-weight: 400;
          color: #666666;

          a {
            margin-right: 0;
          }
        }

        li:hover {
          background: #f96b60;
          a {
            color: #fff;
          }
        }
      }
    }

    .E_contentBox {
      background-color: rgba(0, 0, 0, 0);
      display: flex;
      // > div {
      // 	flex: 1;
      // }

      //导航条上半部分 - 最左边
      .E_contentBox_left {
        display: flex;
        max-width: 25%;

        .E_logo_box {
          height: 1.875rem;
          width: 5.625rem;

          img {
            max-width: 100%;
            height: 100%;
          }
        }

        .E_heng {
          margin: 0 0.5rem;
          width: 1px;
          height: 1.875rem;
          background: linear-gradient(#fcfcfc, #e1e1e1, #fcfcfc);
        }

        .E_Logo_title {
          font-size: 1.125rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #363636;
        }

        > div,
        a {
          margin-right: 1.2rem;
          display: flex;
          align-items: center;

          > i {
            font-size: 0.8rem;
          }

          > p {
            font-size: 0.8rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 3.125rem;
          }
        }

        .E_contentBox_left_three_icon {
          display: block;
          width: 1.2rem;
          height: 1.2rem;
          background: url("/assets/img/E_hrader/icon_01.png") center center
            no-repeat;
          background-size: 1.2rem;
          margin-right: 0.4rem;
        }

        .icon-sanjiaoxiabiaozhengfangxing {
          margin-left: 0.1rem;
        }

        .icon-liebiao2 {
          margin-right: 0.2rem;
        }
      }

      //导航条上半部分 - 最中间
      .E_contentBox_center {
        display: flex;
        margin-left: 9.9rem;
        margin-right: auto;

        > div,
        a {
          margin-right: 1.4rem;
          display: flex;
          align-items: center;

          > i {
            font-size: 0.8rem;
          }

          > p {
            font-size: 0.8rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 3.125rem;
          }

          > .E_contentBox_center_img {
            display: flex;
            align-items: center;
            margin-right: 0.2rem;

            > img {
              max-width: 100%;
              max-height: 100%;
            }
          }
        }
      }

      //导航条上半部分 - 最右边
      .E_contentBox_right {
        display: flex;
        align-items: center;

        .E_contentBox_right_portrait {
          margin-right: 0.6rem;
          width: 1.4rem;
          height: 1.4rem;

          img {
            height: 100%;
          }
        }

        .E_contentBox_right_login {
          min-width: 3rem;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          position: relative;
          font-size: 0.8rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;

          .E_span {
            margin-right: 0.41rem;
            margin-left: 0.41rem;
            display: block;
            width: 1px;
            height: 0.75rem;
            background: #d2d2d2;
          }

          .E_cursor_pointer:hover {
            .hoverColor();
          }

          .E_login_box {
            .flexStyle(row, center, center);
          }

          .E_login_box:hover {
            .E_cursor_pointer {
              .hoverColor();
            }
          }

          > div {
            display: inline-block;
            font-size: 0.8rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 3.125rem;
          }

          > .E_span {
            margin-right: 0.41rem;
            margin-left: 0.41rem;
            display: block;
            width: 1px;
            height: 0.75rem;
            background: #d2d2d2;
          }

          // 已登录状态
          .E_islogin_box {
            .flexStyle(row, center, center);
            height: 100%;

            // 头像
            .E_head_img {
              margin-right: 0.625rem;
              width: 1.5rem;
              height: 1.5rem;
              overflow: hidden;
              border-radius: 50%;
              line-height: normal !important;

              a {
                line-height: normal !important;

                img {
                  width: 100%;
                  height: 100%;
                  line-height: normal !important;
                }
              }
            }

            // 姓名
            .E_name {
              font-size: 0.875rem;
              font-weight: 400;
              color: #666666;
            }

            .E_name:hover {
              .hoverColor();
            }

            // 退出登录
            .E_logout {
              margin-left: 1.5625rem;
              font-size: 0.875rem;
              font-weight: 400;
              color: #bcbcbc;

              .iconfont::before {
                color: #bcbcbc;
                font-size: 0.875rem;
              }
            }

            .E_logout:hover {
              .hoverColor();

              .iconfont::before {
                .hoverColor();
              }
            }
          }
        }
      }
    }
  }

  // 导航条下半部分
  .E_bottom_head_box {
    // 导航条下半部分 搜索
    .E_bottom_head {
      .E_bottom_head_search {
        display: flex;

        // 导航条下半部分 - logo
        .E_bottom_head_search_logo {
          height: 6.2rem;
          display: flex;
          align-items: center;

          img {
            width: 10rem;
            max-height: 100%;
          }
        }

        // 导航条下半部分 搜索
        .E_bottom_head_search_input {
          margin-left: 16rem;
          margin-right: auto;

          .E_bottom_head_search_input_top {
            display: flex;
            width: 30.6rem;
            height: 2.7rem;
            background: linear-gradient(55deg, #ff403a, #ff6948);
            padding: 0.2rem;
            border-radius: 0.2rem;
            position: relative;
            margin-top: 1.3rem;

            .E_bottom_head_search_input_right {
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #fff;
              text-align: center;
              background: #fff;
              width: 4.3rem;

              .E_bottom_head_search_input_right_p {
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
                line-height: 2.8rem;

                input {
                  font-size: 1rem;
                }
              }

              .icon-sanjiaoxiabiaozhengfangxing {
                color: #999999;
              }
            }

            span {
              width: 0.1rem;
              height: 1.6rem;
              background: #dbdbdb;
              left: 4.3rem;
            }

            input {
              width: 22.3rem;
              border: none;
              text-indent: 1rem;

              &::-webkit-input-placeholder {
                /* WebKit browsers */
                font-size: 0.8rem;
              }
            }

            > .icon-search {
              width: 2.2rem;
              height: auto;
              color: #ffffff;
              font-size: 2.2rem;
              text-align: center;
              margin-left: 0.8rem;
            }
          }

          .E_bottom_head_search_input_bottom {
            display: flex;
            width: 28.6rem;
            // overflow: hidden;
            white-space: nowrap;

            P {
              font-size: 0.88rem;
              font-weight: 400;
              color: #9fa19f;
              line-height: 2.81rem;
              margin-right: 1.3rem;

              &:last-child {
                margin-right: 0;
              }
            }

            .E_p_active {
              color: #f22322;
            }
          }
        }

        // 导航条下半部分 地址
        .E_bottom_head_search_right {
          max-width: 20.1rem;
          margin-top: 1.8rem;

          .E_bottom_head_search_right_bottom {
            display: flex;
            flex-wrap: wrap;

            p {
              font-size: 0.88rem;
              font-weight: 400;
              color: #727272;
              line-height: 1.8rem;
              margin-left: 1.1rem;
            }

            .E_bottom_head_search_right_active {
              color: #f22322;
            }
          }
        }
      }
    }

    // 导航条下半部分 导航栏
    .E_bottom_head_navigation {
      width: 100%;
      height: 3rem;
      background-color: #e13b29;

      .E_bottom_head_navigation_flex {
        margin: auto;
        max-width: 87.38rem;
        min-width: 80rem;

        a {
          font-size: 1.13rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 2.8rem;

          > .icon-arrow-down {
            font-size: 1rem;
          }
        }

        .E_navheng {
          font-size: 0.9rem;
          font-weight: 300;
          color: #ffffff;
          line-height: 2.8rem;
          margin-left: 1.74rem;
          margin-right: 1.74rem;
        }
      }
    }
  }
}

// 客服弹框
.E_kefu_tips_parent {
  position: relative;
  cursor: pointer;

  .E_kefu_tips_box {
    border: 1px solid #eee;
    position: absolute;
    z-index: 999;
    top: 0;
    left: 50%;
    width: 11.5rem;
    min-height: 11.5rem;
    color: #666;
    font-size: 0.75rem;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 2px 0.625rem #aaa;
    transition: all 200ms;
    border-radius: 0.3125rem;
    transform: translate(-50%, -100%);
    .flexStyle(column,center,center);
    display: none;

    .E_kefu_tips_box_img {
      width: 8.5625rem;
      height: 8.5625rem;
      margin: 0.625rem auto;

      img {
        max-width: 100%;
        height: 100%;
      }
    }
    .E_kefu_tips_box_title {
      margin: 5px 0;
    }
  }

  .E_kefu_tips_box::after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -0.375rem;
    bottom: -0.8125rem;
    width: 0;
    height: 0;
    border-width: 0.5rem 0.375rem 0.375rem 0.375rem;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }

  // 悬浮在上方（默认）
  .E_kefu_tips_top {
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
  }

  // 悬浮在下方
  .E_kefu_tips_bottom {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 35%);
  }

  .E_kefu_tips_bottom::after {
    left: 50%;
    margin-left: -0.375rem;
    top: -0.8125rem;
    border-color: transparent transparent #fff transparent;
  }
}

.E_kefu_tips_parent:hover {
  .E_kefu_tips_box {
    display: flex;
  }
}
</style>